import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID,
};

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  getAnalytics(app);
}

export const getFirebaseMessageToken = async () => {
  const isSupport = await isSupported();

  if (isSupport) {
    const messaging = getMessaging(app);

    try {
      const tokenId = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAP_ID_KEY,
      });

      return { tokenId };
    } catch (error) {
      console.log("getFirebaseMessageToken", error);
      return { error };
    }
  } else {
    return { error: "Notification Not Supported" };
  }
};

export const requestNotification = async () => {
  if (!("Notification" in window)) {
    console.log("Browser does not support notifications");
    return "";
  }

  if (Notification.permission === "granted") {
    const { tokenId } = await getFirebaseMessageToken();
    return tokenId;
  }

  if (Notification.permission === "default") {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const { tokenId } = await getFirebaseMessageToken();
      return tokenId;
    }
  }

  return "";
};

export default app;